import React from 'react';
import { Helmet } from 'react-helmet-async';
import TopNavbar from '@/components/layout/TopNavbar';
import Footer from '@/components/home/Footer';
import CreatorHeroSection from '@/components/hiveshare-creator/CreatorHeroSection';
import CreatorUseCases from '@/components/hiveshare-creator/CreatorUseCases';
import CreatorFeatures from '@/components/hiveshare-creator/CreatorFeatures';
import CreatorPricing from '@/components/hiveshare-creator/CreatorPricing';
import CreatorTestimonials from '@/components/hiveshare-creator/CreatorTestimonials';
import CreatorFAQ from '@/components/hiveshare-creator/CreatorFAQ';
import CreatorCTA from '@/components/hiveshare-creator/CreatorCTA';

const HiveShareCreator = () => {
  return (
    <div className="min-h-screen bg-white relative">
      <Helmet>
        <title>HiveShare Creator - Share Family Videos Safely for $9/month</title>
        <meta name="description" content="Upload and share your family's activity videos privately. Perfect for parents, private coaches, and homeschool families. No ads, just memories - $9/month." />
        <meta name="keywords" content="family video sharing, private video upload, parent video sharing, homeschool videos, coaching videos, kid activities, safe video platform" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://hivetivity.com/hiveshare-creator" />
        <meta property="og:title" content="HiveShare Creator - Share Family Videos Safely" />
        <meta property="og:description" content="Upload and share your family's activity videos privately. Perfect for parents, private coaches, and homeschool families. No ads, just memories." />
        <meta property="og:image" content="https://media.hivetivity.com/hiveshare-creator-preview.png" />
        
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://hivetivity.com/hiveshare-creator" />
        <meta property="twitter:title" content="HiveShare Creator - Share Family Videos Safely" />
        <meta property="twitter:description" content="Upload and share your family's activity videos privately. Perfect for parents, private coaches, and homeschool families." />
        <meta property="twitter:image" content="https://media.hivetivity.com/hiveshare-creator-preview.png" />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://hivetivity.com/hiveshare-creator" />

        {/* Structured Data for SaaS Product */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "HiveShare Creator",
            "description": "Private video sharing platform for families and individual creators",
            "url": "https://hivetivity.com/hiveshare-creator",
            "applicationCategory": "MultimediaApplication",
            "operatingSystem": "iOS, Web",
            "offers": {
              "@type": "Offer",
              "price": "9",
              "priceCurrency": "USD",
              "priceValidUntil": "2025-12-31"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Hivetivity"
            }
          }
        `}</script>
      </Helmet>

      {/* Sticky Header */}
      <TopNavbar />

      {/* Main Content */}
      <main>
        <CreatorHeroSection />
        <CreatorUseCases />
        <CreatorFeatures />
        <CreatorPricing />
        <CreatorTestimonials />
        <CreatorFAQ />
        <CreatorCTA />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HiveShareCreator;